export const adminTabs = {
  receivable: '0',
  payable: '1'
}

export const ADMIN_TABS = [
  {
    value: adminTabs.receivable,
    label: 'Accounts receivable'
  },
  {
    value: adminTabs.payable,
    label: 'Accounts payable'
  }
]
